<template>
	<div>
		<PageHeader
			:data="{
				name: contact.first_name + ' ' + contact.last_name,
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Client contacts', to: '/client-contacts' },
				],
			}"
		/>
		<form @submit.prevent="updateContact">
			<div class="row">
				<div class="col-md-12 mb-2">
					<div class=" p-2 d-flex justify-content-between align-items-center">
						<router-link :to="'/clients/edit/' + client.id" class="btn btn-primary">← Back to client</router-link>
						<div v-if="client.municipality" class="d-flex justify-content-center align-items-center">
							<h6 class="p-0 m-0 me-2">
								🏛️
								<router-link :to="'/municipalities/edit/' + client.municipality.id">{{ client.municipality.full_name }}</router-link>
								| {{ client.municipality.state }} | {{ client.municipality.county }} | 👪
								{{ client.municipality.population }}
							</h6>
						</div>
					</div>
				</div>

				<div class="col-4">
					<div class="card mb-2">
						<div class="card-body">
							<div class="row mb-0 pb-1 border-bottom pb-2 mb-2">
								<div class="col-2">
									<h1 class="p-0 m-0" role="button" @click="goToContacts()">🧑</h1>
								</div>
								<div class="col-10">
									<h4 class="mb-0 p-0">{{ contact.first_name }} {{ contact.last_name }}</h4>
									<a :href="'mailto:' + contact.email">{{ contact.email }}</a>
								</div>
							</div>
							<div class="row">
								<div class="col-12 d-flex justify-content-between mb-2">
									<span>Created</span>
									<span>{{ contact.created_at | localDate }}</span>
								</div>
								<div class="col-12 d-flex justify-content-between mb-2">
									<span>Status</span>
									<span v-if="contact.status === 'active'" class="badge badge-success bg-success">
										active
									</span>
									<span v-if="contact.status === 'deleted'" class="badge badge-danger bg-danger">
										active
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-8">
					<div class="card mb-2">
						<div class="card-body">
							<div class="row">
								<div class="col-12">
									<div class="d-flex justify-content-start align-items-center">
										<h5 class="p-0 m-0 me-1">Contact info</h5>
										<button
											data-bs-toggle="offcanvas"
											data-bs-target="#offcanvasActivities"
											aria-controls="offcanvasActivities"
											class="btn btn-link btn-sm p-0 m-0 mt-1"
											title="Contact history of changes"
											type="button"
										>
											<font-awesome-icon :icon="['fas', 'history']" />
										</button>
									</div>
									<div class="form-group">
										<label for="">First Name</label>
										<input type="text" class="form-control" name="first_name" v-model="contact.first_name" required />
									</div>
									<div class="form-group">
										<label for="">Last Name</label>
										<input type="text" class="form-control" v-model="contact.last_name" required />
									</div>
									<div class="form-group">
										<label for="">Address</label>
										<input type="text" class="form-control" v-model="contact.address" />
									</div>
									<div class="form-group">
										<label for="">Email</label>
										<input type="email" class="form-control" v-model="contact.email" required />
									</div>
									<div class="form-group">
										<label for="">Phone</label>
										<input type="text" class="form-control" v-model="contact.phone" />
									</div>
									<div class="form-group">
										<label for="">Title</label>
										<input type="text" class="form-control" v-model="contact.title" required />
									</div>
									<div class="form-group">
										<label for="">Type</label>
										<input type="text" class="form-control" v-model="contact.type" />
									</div>
									<div class="form-group">
										<label for="">Email secondary</label>
										<input type="email" class="form-control" v-model="contact.email_secondary" />
									</div>
									<div class="form-group">
										<label for="">Phone secondary</label>
										<input type="text" class="form-control" v-model="contact.phone_secondary" />
									</div>
									<div class="mt-3">
										<small>(If you already have selected main contact for this client, selecting another will deselect old one)</small>
									</div>
									<div class="form-check form-switch mb-2 d-flex justify-content-start align-items-center">
										<input class="form-check-input" v-model="contact.main" type="checkbox" id="main" />
										<label class="form-check-label ms-2" for="main">Main contact </label>
									</div>
									<div class="mt-3">
										<small>(If you already have selected billing contact for this client, selecting another will deselect old one)</small>
									</div>
									<div class="form-check form-switch mb-2 d-flex justify-content-start align-items-center">
										<input class="form-check-input" v-model="contact.billing" type="checkbox" id="billing" />
										<label class="form-check-label ms-2" for="billing">Billing contact </label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<button v-if="authUser.permissions.includes('CLIENT_CONTACT_UPDATE')" type="submit" class="btn btn-primary float-end">
						Update
					</button>
				</div>
			</div>
		</form>
		<Activities :key="activityKey" :subjectType="'App\\Models\\ClientContact'" :subjectId="$route.params.id" />
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import restApi from '../../api/index.js'
import { handleErrors } from '../../actions/helpers'
import Activities from '@/components/Activities'

export default {
	name: 'ClientContactEdit',
	components: { PageHeader, Activities },
	data() {
		return {
			loading: false,
			contact: {
				name: 'Contact',
			},
			client: {},
			masterContact: null,
			loadingClient: false,
			logs: null,
			activeHistory: {},
			activityKey: 0,
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
	},
	created() {
		this.loadingClient = true
		this.getContact()
	},
	methods: {
		// Get Client
		getContact() {
			restApi
				.get(`/client-contacts/${this.$route.params.id}`)
				.then(({ data }) => {
					this.contact = data
					this.getClient()
					//this.getSubjectLogs()
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		getSubjectLogs() {
			restApi
				.post(`helper/activity/${this.contact.client_id}/Client`)
				.then(({ data }) => {
					this.logs = data
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		getClient() {
			restApi
				.get(`/clients/${this.contact.client_id}`)
				.then(({ data }) => {
					this.client = data
					this.loadingClient = false
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Update Client
		updateContact() {
			restApi
				.put(`/client-contacts/${this.$route.params.id}`, this.contact)
				.then(() => {
					this.activityKey++
					this.$swal.fire({
						icon: 'success',
						title: 'Client contact successfully updated!',
						timer: 3000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Go to contacts
		goToContacts() {
			if (this.contact.contact_id) {
				// Take client to municipal clients table
				console.info(this.contact.contact_id)
			} else {
				alert('There is no connection!')
			}
		},

		setActiveHistory(activity) {
			this.activeHistory = activity
		},
	},
	mounted: function() {},
	watch: {},
	filters: {
		localDate: function(value) {
			if (!value) return ''
			value = new Date(value)
			return value.toLocaleDateString()
		},
		localDateTime: function(value) {
			if (!value) return ''
			value = new Date(value)
			return value.toLocaleString()
		},
	},
}
</script>
